import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEn from "../assets/locale/en.json";
import translationRu from "../assets/locale/ru.json";
import translationUk from "../assets/locale/uk.json";

i18n.use(LanguageDetector).init({
  resources: {
    en: {
      translations: translationEn
    },
    uk: {
      translations: translationUk
    },
    ru: {
      translations: translationRu
    },
  },
  supportedLngs: ["en", "ru", "uk"],
  fallbackLng: "en",
  lowerCaseLng: true,
  debug: true,
  // have a common namespace used around the full app
  ns: ["translations"],
  defaultNS: "translations",
  interpolation: {
    escapeValue: false, // not needed for react!!
  },
  react: {
    wait: true
  }
});

export const getLanguage = () => {
  return 'en';
};


export default i18n;
